import axios, { AxiosError, AxiosRequestConfig } from "axios"
import { InternalAxiosRequestConfig } from "axios"
import { i18n } from "./i18n"
import { getAllToken, getToken, removeToken, setToken } from "@/utils/index"
import router from "@/router"
import message from "ant-design-vue/es/message"
import { getUserInfo, refreshToken } from "@/services"
const { t, te } = i18n.global

export interface ResDataType<T> {
  code?: number
  data?: T
  msg?: string
}
let source = axios.CancelToken.source()
let baseURL = import.meta.env.VITE_API_URL
// let host = localStorage.getItem("HOST")

// if (host) {
//   baseURL = host + "/v1"
// }
// if (import.meta.env.MODE === "development") {
//   console.log("当前是开发环境", import.meta.env.MODE)
//   baseURL = import.meta.env.BASE_URL + "v1"
// }
// console.log("真实请求地址", baseURL)

const instance = axios.create({
  timeout: 60000,
  baseURL,
  withCredentials: true
})

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (!config.headers.Authorization && getToken()) {
    config.headers.Authorization = getToken()
  }
  return config
})

let refreshTarget = false
const requests: Array<{ next: Function }> = []
const refreshing = Object.create(null)
Object.defineProperty(refreshing, "value", {
  get() {
    return refreshTarget
  },
  set(v) {
    refreshTarget = !!v
    if (!v) {
      requests.forEach((instance) => instance.next())
      requests.length = 0
    }
  }
})
instance.interceptors.response.use(
  async ({ config, data, status }) => {
    if (data.code == 0) {
      return data
    } else if (data.code == 1055) {
      source.cancel("1055")
      // source = axios.CancelToken.source()
      removeToken()
      router.replace("login")
      return Promise.reject({ data: "1055" })
      // return message.error(t("1055"))
    } else if (data.code == 1008 || data.code == 1009) {
      if (config.url?.includes("refreshtoken")) {
        return Promise.reject({ data: "E_INVALID_OR_EXPIRED_TOKEN" })
      }

      if (refreshing.value) {
        return await new Promise((resolve, reject) => {
          config.headers.Authorization = ""
          const next = async () => {
            try {
              const res = await instance({ ...config, cancelToken: source.token })
              resolve(res)
            } catch (err) {
              reject(err)
            }
          }
          requests.push({ next })
        })
      } else {
        try {
          refreshing.value = true
          const token = getAllToken()
          if (!(token.token && token.rToken)) throw "noToken"
          const { data: newToken, msg } = await refreshToken(token.rToken, token.token)
          if (msg) throw "refreshErr"
          setToken(newToken, token.rToken)
          config.headers.Authorization = ""
          return await instance(config)
        } catch (err) {
          refreshing.value = false
          source.cancel("401")
          source = axios.CancelToken.source()
          removeToken()
          localStorage.removeItem("HOST")
          router.replace("login")
          if (err == "refreshErr") {
            return Promise.reject({ data: "E_INVALID_OR_EXPIRED_TOKEN" })
          } else {
            return null
          }
        } finally {
          refreshing.value = false
        }
      }
    } else if (data.code) {
      // return Promise.reject(data)
      return Promise.reject({ data: data.code, realData: data.data })
    } else if (status == 200 && config.responseType == "blob") {
      return data
    } else {
      return Promise.reject({ data: "ERR_BAD_RESPONSE" })
    }
  },
  (err: AxiosError) => {
    return Promise.reject(err)
  }
)

type CusCofing = {
  showMask?: boolean
  manual?: boolean
  duration?: number
  type?: "data" | "file"
} & AxiosRequestConfig

const request = async <T>(config: CusCofing): Promise<ResDataType<T>> => {
  const duration = config?.duration || 2.5
  try {
    // 默认 baseURL
    let host = localStorage.getItem("HOST")
    // console.log("请求的地址", host)
    if (host) {
      instance.defaults.baseURL = host + "/v1"
    }

    // if (host && import.meta.env.VITE_ENV == "production") {
    //   instance.defaults.baseURL = host + "/v1"
    // }
    // 本地开发调试
    if (import.meta.env.MODE === "development") {
      // console.log("当前是开发环境")
      instance.defaults.baseURL = import.meta.env.BASE_URL + "v1"
      // baseURL = import.meta.env.BASE_URL + "v1"
    }

    const whiteList = [
      // "login",
      "removal",
      "register",
      "forgetverify",
      "modifyPwd",
      "phoneverify",
      "resendmail",
      "/global/activate"
    ]
    if (whiteList.some((key) => config?.url?.includes(key)) && import.meta.env.VITE_ENV == "production") {
      // instance.defaults.baseURL = "https://hms.vidagrid.com" + "/v1"
      // instance.defaults.baseURL = host + "/v1"
      // baseURL = host + "/v1"
    }

    // 登录单独处理国内打包（暂未使用）
    // if (config.url?.includes("/global") && import.meta.env.VITE_TYPE == "cn") {
    //   instance.defaults.baseURL = "https://hms-cn.vidagrid.com" + "/v1"
    // }

    const response = await instance({ ...config, cancelToken: source.token })

    if (config.type == "file") {
      return response
    } else {
      return { data: response.data }
    }
  } catch (error: any) {
    console.log("re", error, config.manual)
    if (error?.name == "AxiosError" && config?.manual) {
      return { msg: error.code }
    }
    if (error?.name == "AxiosError") {
      message.error(`${t(error.code)}`, duration)
      return Promise.reject({ msg: error.code })
    } else if (error?.name == "CanceledError") {
      return Promise.reject({ msg: error.code })
    } else if (!config?.manual) {
      if (te(error?.realData)) {
        message.error(t(error?.realData), duration)
      } else if (te(error?.data)) {
        message.error(t(error?.data), duration)
      } else {
        message.error(t(error?.code), duration)
      }
      //请求成功,但是返回错误
      return { msg: error.data, code: error?.code }
    } else {
      return { msg: error.data, code: error?.code, data: error.realData }
    }
  }
}

export { instance, request }
